import React from "react";
import { usePersonalization } from "../lib/personalization";
import { useContent } from "../lib/content";
import { Phone, Mail, Sparkles } from "lucide-react";

export default function Vendors() {
  const { p } = usePersonalization();
  const { content } = useContent();
  const custom = (p.custom_vendors || []).map((v) => ({ ...v, fromAgent: true }));
  const all = [...custom, ...(content.vendors || [])];

  const grouped = all.reduce((acc, v) => {
    (acc[v.category] = acc[v.category] || []).push(v); return acc;
  }, {});

  return (
    <div className="container-x" style={{ padding: "48px 0 64px" }}>
      <span className="overline">Vendor contacts</span>
      <h1 className="font-serif" style={{ fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 500, margin: "8px 0 12px", letterSpacing: "-0.01em" }}>
        Trusted pros for every corner of your sale.
      </h1>
      <p style={{ color: "var(--text-muted)", maxWidth: 680 }}>
        A curated directory — agent-picked recommendations appear first.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24, marginTop: 40 }}>
        {Object.entries(grouped).map(([cat, items]) => (
          <div key={cat} className="card" style={{ padding: 24 }} data-testid={`vendor-cat-${cat.toLowerCase()}`}>
            <div className="overline">{cat}</div>
            <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 14 }}>
              {items.map((v, i) => (
                <div key={(v.id || v.name) + i} style={{ paddingBottom: 12, borderBottom: "1px solid var(--border)" }} data-testid={`vendor-${(v.name || "").replace(/\s+/g, "-").toLowerCase()}`}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                    <span style={{ fontWeight: 600 }}>{v.name}</span>
                    {v.fromAgent && <span className="badge" style={{ background: "#FBECE8", color: "var(--secondary)", display: "inline-flex", alignItems: "center", gap: 4 }}><Sparkles size={10} /> Recommended</span>}
                  </div>
                  {v.note && <div style={{ color: "var(--text-muted)", fontSize: 13, marginTop: 4, fontStyle: "italic" }}>{v.note}</div>}
                  <div style={{ color: "var(--text-muted)", fontSize: 14, display: "flex", flexDirection: "column", gap: 4, marginTop: 6 }}>
                    {v.phone && <a href={`tel:${v.phone}`} style={{ color: "inherit", display: "flex", alignItems: "center", gap: 6 }}><Phone size={13} /> {v.phone}</a>}
                    {v.email && <a href={`mailto:${v.email}`} style={{ color: "inherit", display: "flex", alignItems: "center", gap: 6 }}><Mail size={13} /> {v.email}</a>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
